import script from "./ContactLacen.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactLacen.vue?vue&type=script&setup=true&lang=js"

import "./ContactLacen.vue?vue&type=style&index=0&id=0fb45a0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb45a0f"]])

export default __exports__